import type { ParsedUrlQuery } from 'querystring';

import type { TFilter } from '~/domains/common/components/Filters/types';

export type TFilterObject<VT = unknown> = {
  object: TFilter<VT>;
  fromQuery?: (query: ParsedUrlQuery) => VT;
  toQuery?: (value: VT) => ParsedUrlQuery;
};

/**
 * Factory function to create default fromQuery and toQuery functions for filter descriptors.
 * @param filterDescriptors - The object containing the filter descriptors.
 * @returns The filter descriptors object.
 */
export function filterDescriptorFactory(filterDescriptors: Record<string, TFilterObject>) {
  for (const [FILTER_KEY, filterDescriptor] of Object.entries(filterDescriptors)) {
    const urlQueryKey = filterDescriptor.object.key;
    const filterType = filterDescriptor.object.type;

    if (!filterDescriptor.fromQuery) {
      const fromQuery = (query: ParsedUrlQuery) => query[urlQueryKey]
        ? [query[urlQueryKey]]
        : undefined;

      Object.assign(filterDescriptors[FILTER_KEY], { fromQuery });
    }

    if (!filterDescriptor.toQuery) {
      const toQuery = (value?: string) => {
        const v = value?.[0];
        if (!v) return { [urlQueryKey]: null };
        return { [urlQueryKey]: v };
      }

      Object.assign(filterDescriptors[FILTER_KEY], { toQuery });
    }
  }
  return filterDescriptors;
};
